// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

export const DebugOverlay = () => {
  return (
    <div className={'debug-overlay'}>
      {[...Array(24).keys()].map(idx => {
        const className = classNames(`div-${idx}`, {
          alt: idx % 2 === 0,
        });

        return <div className={className} key={idx} />;
      })}
    </div>
  );
};
